// Shared money formatter. Falls back to "CUR 0.00" when Intl doesn't
// recognise the currency code (defensive — the catalog should always
// send a valid ISO-4217 code from the product's mall).
export function formatPrice(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount)
  } catch {
    return `${currency} ${amount.toFixed(2)}`
  }
}
